import React from 'react';
import {Field} from 'redux-form';
import {TextField} from 'redux-form-material-ui';
import {required, email} from '../../lib/validators';
import RaisedButton from 'material-ui/RaisedButton';
import BranchSelectorInput from '../branchSelector/BranchSelectorInput'
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Toggle } from 'redux-form-material-ui';
import Divider from 'material-ui/Divider';

const UserForm = (props) => {
    const {handleSubmit, openModalDeleteUser, resetSearch, inviteUser} = props;

    const styles = {
        block: {
            maxWidth: 250,
        },
        toggle: {
            marginBottom: 16,
        },
        thumbOff: {
            backgroundColor: '#ffcccc',
        },
        trackOff: {
            backgroundColor: '#ff9d9d',
        },
        thumbSwitched: {
            backgroundColor: 'red',
        },
        trackSwitched: {
            backgroundColor: '#ff9d9d',
        },
        labelStyle: {
            color: 'red',
        },
    };

    const reInvite = (name) => {
        inviteUser(props.user.username);
    };

    return (
        <form onSubmit={handleSubmit}>

            <Grid fluid>
                <Row>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <h2>Edit User</h2>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <div style={{textAlign: 'right', marginTop: '15px'}}>
                            {props.user ? <RaisedButton type="submit" backgroundColor="#fff" primary={true} label={props.user.id === 0 ? "Save and invite" : "Save"} style={{margin: '5px'}}/>:""}
                            {props.user && props.user.deleteable && (<RaisedButton type="button" backgroundColor="#fff" label="Delete" onTouchTap={openModalDeleteUser} style={{margin: '5px'}}/>)}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={8} sm={8} md={8} lg={8} >
                        <div>
                            <Field name="username" validate={[required, email]} component={TextField}
                                   hintText="Username (should be an email)" floatingLabelText="Username"/>
                        </div>
                        <div style={styles.block}>
                            <Field name="enabled" component={Toggle} label="Enabled" />
                        </div>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4}>
                        <div style={{textAlign: 'right'}}>
                            {props.user && props.user.id !== undefined && props.user.displayName === '' ? (<RaisedButton type="button" backgroundColor="#fff" label="Invite again" onTouchTap={reInvite} style={{margin: '5px'}}/>):""}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} >
                        <Divider style={{marginTop: '20px', marginBottom: '20px'}}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} >
                        <BranchSelectorInput name="useraccess" resetSearch={resetSearch}/>
                    </Col>
                </Row>
            </Grid>
        </form>
    );
};

export default UserForm;







// WEBPACK FOOTER //
// ./src/components/userForm/UserForm.js